const compare = require('./compare')
const neq = (a, b, loose) => compare(a, b, loose) !== 0
module.exports = neq



//////////////////
// WEBPACK FOOTER
// ./~/semver/functions/neq.js
// module id = 738
// module chunks = 0